import React, { useContext } from 'react';
import { IColumnDef } from '../../../../../../Types/ColumnDefType';
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';
import {
  findValue,
  getAttributeFormatter,
} from '../ObjectTable/ObjectTableRow';
import { IClientBusinessModel } from '../../../../../../Types/ClientModelTypes';
import { ModelContext } from '../../../../../../Model/ModelContext/ModelContext';
import { findDisplayComp } from '../../../Const/BusinessConfigs';
import { getCaption } from '../../../../../../Model/BusinessModelUtils';
import { useBusinessConfig } from '../../../../../../Components/BusinessConfigContext/BusinessConfigContext';
import EDBox from '../../../../../../BaseComponents/EDBox/EDBox';
import { MASKED_VALUE_TEXT } from '../../../Hooks/useAttributeValues';

interface IProps {
  column: IColumnDef;
  item: { id: string; _version: number };
  collection: IClientBusinessModel;
  isMiniCard?: boolean;
  masked?: boolean;
}

const BusinessValuePair: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { avenyCollectionMap } = useContext(ModelContext);

  const { formatter, displayParams } = getAttributeFormatter(
    props.column.attributeDef,
    props.collection,
    avenyCollectionMap
  );

  const value =
    findValue(props.item, props.column.attributeDef.split('.')) ?? '';

  const displayValue = formatter.displayer.display(value, true, displayParams);

  const DisplayComp = findDisplayComp(
    props.collection.CollectionName,
    props.column.attributeDef
  );
  const businessconfig = useBusinessConfig(props.collection.CollectionName);
  const optionalLabel =
    businessconfig?.attributes?.[props.column.attributeDef]?.optionalLabel;

  const label = getCaption(props.column, props.collection, avenyCollectionMap);
  return (
    <EDBox
      key={props.column.attributeDef}
      sx={{ width: '100%', display: 'flex' }}
    >
      {!props.column.hideCaption &&
        !optionalLabel &&
        !(props.isMiniCard && value === '') && (
          <EDBox sx={{ paddingTop: props.isMiniCard ? 0 : 0.5 }}>
            <EDTypography variant={props.isMiniCard ? 'caption' : 'body2'} bold>
              {`${label}:`}
              &nbsp;
            </EDTypography>
          </EDBox>
        )}
      <EDBox sx={{ paddingTop: props.isMiniCard ? 0 : 0.5 }}>
        <EDTypography
          variant={props.isMiniCard ? 'caption' : 'body2'}
          color={props.isMiniCard ? 'inherit' : ''}
        >
          {props.masked ? (
            MASKED_VALUE_TEXT
          ) : DisplayComp ? (
            <DisplayComp value={value} displayValue={displayValue} />
          ) : (
            (displayValue as string)
          )}
        </EDTypography>
      </EDBox>
    </EDBox>
  );
};

export default BusinessValuePair;
